const STEPS = [
  { n: '01', time: 'Weeks 1–2', title: 'Discovery', desc: 'Workshops, user flows and a written scope with the risks named up front.' },
  { n: '02', time: 'Weeks 3–4', title: 'Design and architecture', desc: 'Clickable prototype, data model and system design, agreed before build.' },
  { n: '03', time: 'Two-week sprints', title: 'Build', desc: 'A demo every sprint, a staging link you can use, a backlog you control.' },
  { n: '04', time: 'Ongoing', title: 'Launch and support', desc: 'Production rollout, monitoring and a maintenance plan with response times.' },
];
export default STEPS;
